module.exports = __webpack_public_path__ + "img/ICON_2.220010c0.png";